<bci-wk-modal class="modal">
  <img class="war" src="./assets/images/Seal-2.png" alt="waricon" />
  <div class="title wk-padding-top-24">
    <bci-wk-modal-title bciWkTypeH600 class="title-modal">{{
      title
    }}</bci-wk-modal-title>
  </div>
  <div class="subtitle">
    <p>¡No te preocupes! Puedes pedir un nuevo código y reintentarlo.</p>
  </div>
  <bci-wk-modal-actions>
    <div class="botonera">
      <button (click)="close()" bciWkButtonPrimary>Pedir nuevo código</button>
    </div>
  </bci-wk-modal-actions>
</bci-wk-modal>
